<template>
  <el-dialog title="提现" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
    <el-form ref="dataForm" label-position="right" :rules="formRules" :model="form" size="small"
      label-width="130px">
      <el-form-item label="提现金额：" prop="name" class="width100">
          <el-input placeholder="当前账户最多提现****元" v-model="form.name">
            <template slot="append">元</template>
          </el-input>
      </el-form-item>
      <div class="tip-title">服务费{{serviceCharge}}元</div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import cityCompanyApi from '@/api/sys/cityCompany'
  import sysDataconstantApi from '@/api/config/sysDataconstant'
  function initFormBean() {
    const formBean = {
      name: null
    }
    return formBean
  }

  export default {
    data() {
      return {
        form: initFormBean(),
        formVisible: false,
        serviceCharge:0,
        isLoading:false,
        formRules: {
          name: [{
            required: true,
            message: '请输入提现金额',
            trigger: 'blur'
          },{ pattern: /^(?!0(\.0+)?$)(\d+(\.\d+)?|\.\d+)$/, message: '请输入正确的金额'}
          ],
        }
      }
    },
    created() {
      this.getConfig()
    },
    methods: {
      // 获取系统配置
      getConfig() {
        sysDataconstantApi.fetchBatchCode({
          code: 'toCashAmountCommission'
        }).then(({
          data
        }) => {
          this.serviceCharge = data.list[0].content
          // console.log("配置: ", data);
        })
      },
      resetForm() {
        this.form = initFormBean()
      },
      handleCreate() {
        // console.log('row: ',id,type);
        this.resetForm()
        this.formVisible = true
        this.$nextTick(async() => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      doCreate(){

      },
      postCallback(data) {
        this.$message.success('操作成功')
        this.formVisible = false;
        this.$emit('created')
      },
    }
  }
</script>
<style lang="scss" scoped>
  .tip-title{
    padding-left: 130px;
    color: #878787;
  }

  ::v-deep .el-select {
    width: 100%;
  }

  ::v-deep .el-cascader {
    width: 100%;
  }

  ::v-deep .el-input {
    width: 100%;
  }

  .el-form-item--small.el-form-item {
    width: 48%;
    display: inline-block;
    vertical-align: top;
  }

  .el-date-editor--datetimerange.el-input,
  .el-date-editor--datetimerange.el-input__inner {
    width: 100%;
  }

  .el-form-item--small.el-form-item.width100 {
    width: 97%;
  }
</style>
